import axios from '../lib/axios';
import { LoginCredentials, AuthResponse } from '../types/auth';

export const authService = {
  login: async (credentials: LoginCredentials) => {
    const { data } = await axios.post<AuthResponse>('/auth/login', {
      phone: credentials.phone,
      password: credentials.password,
      roles: ['ADMIN']
    });
    return data;
  },

  refreshToken: async (refreshToken: string) => {
    const { data } = await axios.post<AuthResponse>('/auth/token', {
      refresh_token: refreshToken
    });
    return data;
  }
}; 